export const environment = {
    production: false,
    apiUrl: 'https://inge2-api-dv.azurewebsites.net/api',
    urlRoot: 'https://dev.app.inge.cl',
    recaptcha: {
      siteKey: '6LfEgncoAAAAABObDfendvxDlZ9yKR8FL9AwqB3q',
    },
    nminutelimitold: 100,
    apiUrlCRM:'https://green-island-037b5d60f.3.azurestaticapps.net/#/deal/',
    apiKeyTinyEditor: 'crysjxbt8ma13oc9mywbywcvfcepxftathlcddq3c0if0zd8',
  };
